import React, { useState } from "react";
import BasicDataTable from "../../../Component/BasicComponents/BasicDataTable";
import RouteModal from "../../../Component/BasicComponents/Modal/RouteModal";
import CommonForm from "./CommonForm";
import { FaEdit } from "react-icons/fa";
import { useGetAgendaList } from "./UseAgenda";

type props = {};

const AgendaTableColumns = (handleEdit: (row: any) => void) => [
  {
    name: "Agenda Name",
    selector: (row: { AgendaName: string }) => row.AgendaName,
  },
  {
    name: "Agenda Control Type",
    selector: (row: { AgendaControlType: string }) => row.AgendaControlType,
  },
  {
    name: "Org Unit Name",
    selector: (row: { OrgUnitName: string }) => row.OrgUnitName,
  },
  {
    name: "Status",
    selector: (row: { Status: string }) => row.Status,
  },
  {
    name: "Actions",
    cell: (row: any) => (
      <div className="d-flex align-items-center gap-2">
        <button
          className="btn btn-primary"
          onClick={()=>handleEdit(row)}
          style={{ borderRadius: "20px", padding: "5px", width: "80px" }}
        >
          <FaEdit size={18} style={{ fill: "#fff" }} /> Edit
        </button>
      </div>
    ),
  },
];

const AgendaTable = (Props: props) => {
    
    const [isModal, setIsModal] = useState(false);
    const [mode,setMode] = useState('add');
    const [row,setrow]  = useState();
    const [filterData,setFilterData] = useState({
    page:1,
    limit:10,
    search:''    
 })
  
   
  const{data,isLoading,isSuccess} = useGetAgendaList({enabled:true,params:{
    page:filterData.page,
    limit:filterData.limit,
    search:filterData.search   
  }})

  const handleEdit = (row:any) => {
    setMode('edit')
    setrow(row);
    setIsModal(true);
  };

  const toggle = () => {
    setIsModal(!isModal);
  };
  
  const handleOnChangeRowsPerPage=(limit:any,page:any)=>{
    setFilterData((prev:any)=>({
           ...prev,
            limit:limit,
            page:page
    }));
  }

  const handlePagination=(page:number)=>{
      setFilterData((prev:any)=>({
        ...prev,
        page:page
      }));
  }

const handleSerach=(val:string)=>{
  setFilterData((prev:any)=>({
    ...prev,
    search:val,
  }))
}

  return (
    <>
      <BasicDataTable
        Title="Agenda List"
        showSpinner={isLoading}
        columns={AgendaTableColumns(handleEdit)}
        data={(!isLoading && isSuccess && data?.data) || []}
         paginationTotalRows={(data?.rowData?.data?.total) || 0}
         onChangeRowsPerPage={(newPerPage:any,page:any)=>handleOnChangeRowsPerPage(newPerPage,page)}
         onChangePage={(pageNo:number)=>handlePagination(pageNo)}
         handleSearch={(val:any)=>handleSerach(val)}
      />
      <RouteModal
        size="md"
        toggle={toggle}
        isOpen={isModal}
        title={mode ==="add" ? 'Add Agenda' :'Edit Agenda'}
        content={
        <CommonForm onPressForCancilModal={toggle} setIsModal={setIsModal} rowData={row} mode={mode}/>
       }
      />
    </>
  );
};

export default AgendaTable;
